export const AVAILABLE_TYPES = [
  'string',
  'boolean',
  'integer',
  'array',
  'enum',
];
